module.exports = __webpack_public_path__ + "img/_unitedkingdom.5f5d5615.png";